import post_req from '../funzioni_server/richiesta_generale.js'
import { setToken,setUserId,removeToken,removeUserId } from "../auth";
const funzione_collegamento = async ({userid=undefined,date=undefined, token=undefined,logout_on_error=true,group=undefined,getid,setId=undefined,delId=undefined,valori=undefined,azione=undefined,return_data=true,filtri=undefined,childs=undefined}) => {
        var dati={}
        dati["action"]=azione
        dati['token']=token
        dati['userid']=userid
        if (setId!==undefined){
        dati['setid']=setId
        }
        if (delId!==undefined){
        dati['delid']=delId
        }
        if (valori!==undefined) {dati['values']=JSON.stringify(valori)}
        if (filtri)
        {
        for (let filtro in filtri){
        dati[filtro]=filtri[filtro]
        }
        }
        if (childs) {
            dati["childs"]=JSON.stringify(childs)
        }
        if (group){
            dati["whatsapptbl"]=group
        }
        if (getid){
            dati["getid"]=getid
        }
        if (date){
            dati["date"]=date
        }
        const response = await post_req({request:dati,logout_on_error:logout_on_error,return_data:return_data})
        //console.log(dati,response)
if (response){return response.data}
else {return []}

};
export default funzione_collegamento